import { __extends, __makeTemplateObject, __decorate, __metadata, __assign as _assign } from '../../node_modules/tslib/tslib.es6.js';
import '../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import { nothing as A, html as x } from '../../node_modules/lit-html/lit-html.js';
import '../../node_modules/lit-element/lit-element.js';
import { property as n } from '../../node_modules/lit/node_modules/@lit/reactive-element/decorators/property.js';
import '../../node_modules/@babel/runtime/regenerator/index.js';
import '../../node_modules/lit/node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { ifDefined as l } from '../../node_modules/lit-html/directives/if-defined.js';
import { unsafeHTML as o } from '../../node_modules/lit-html/directives/unsafe-html.js';
import getClassName from '../../node_modules/@fmr-ap142296/brick-helpers/dist/src/functions/get-class-name.js';
import { ScopedElementsMixin } from '../utilities/scoped-elements/scoped-elements.mixin.js';
import { PvdBaseComponent } from '../pvd-base-component/pvd-base-component.js';
import { IconPosition } from '../pvd-utils/enums/icon-position.js';
import { Inline } from '../pvd-utils/enums/inline.js';
import { StandardSize, Size } from '../pvd-utils/enums/size.js';

var ListStyle;
(function (ListStyle) {
    ListStyle["none"] = "none";
    ListStyle["ordered"] = "ordered";
    ListStyle["unordered"] = "unordered";
})(ListStyle || (ListStyle = {}));
var DEFAULT_BORDERS = false;
var DEFAULT_ENABLE_UNSAFE_HTML = false;
var DEFAULT_INLINE = Inline.never;
var DEFAULT_LIST_STYLE = ListStyle.none;
var DEFAULT_SIZE = StandardSize.medium;
/**
 * Providence List Group component.
 * @see {@link https://providence.fmr.com/components/list-group/list-group.html|List Group documentation}
 */
var PvdListGroup = /** @class */ (function (_super) {
    __extends(PvdListGroup, _super);
    function PvdListGroup() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.pvdBorders = DEFAULT_BORDERS;
        _this.pvdEnableUnsafeHTML = DEFAULT_ENABLE_UNSAFE_HTML;
        _this.pvdInline = DEFAULT_INLINE;
        _this.pvdListItems = [];
        _this.pvdSize = DEFAULT_SIZE;
        _this.pvdListStyle = DEFAULT_LIST_STYLE;
        return _this;
        // #endregion
    }
    Object.defineProperty(PvdListGroup, "scopedElements", {
        get: function () {
            // $namespace-$name-$extendingComponentName
            return {
                'pvd-scoped-list-group': customElements.get("".concat(this.namespace, "-list-group")),
                'pvd-scoped-icon': customElements.get("".concat(this.namespace, "-icon")),
                'pvd-scoped-link': customElements.get("".concat(this.namespace, "-link")),
            };
        },
        enumerable: false,
        configurable: true
    });
    //#endregion
    // #region LitElement lifecycles
    /**
     * Render a list item. Basic strings will render using the values of the
     * custom element attributes and objects will render with a preference for
     * their local configuration.
     * @param listItem
     * @param listItemIndex
     */
    PvdListGroup.prototype.renderListItem = function (listItem, listItemIndex) {
        if (typeof listItem === 'string') {
            return this.renderListItemString(listItem, listItemIndex);
        }
        else {
            return this.renderListItemObject(listItem, listItemIndex);
        }
    };
    /**
     * Render a basic list item using the values of the custom element attributes.
     * @param listItem string that will render as the list item text
     * @param listItemIndex position of the list item within the list, starts at 0
     */
    PvdListGroup.prototype.renderListItemString = function (listItem, listItemIndex) {
        var text = this.renderText(listItem);
        var leftIcon = this.pvdIconLeft
            ? this.renderIcon(IconPosition.left, this.pvdIconLeft)
            : A;
        var iconRight = this.pvdIconRight
            ? this.renderIcon(IconPosition.right, this.pvdIconRight)
            : A;
        // left icons take the place of ordered and unordered list style
        var iconOrListStyle = leftIcon !== A ? leftIcon : this.renderListItemStyle();
        var className = this.createClassName({
            default: 'pvd-list-group__list-item',
            modifierPrefix: 'pvd-list-group__list-item',
            border: {
                condition: this.pvdBorders && listItemIndex > 0,
                className: 'border',
            },
        });
        return x(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      <li class=\"", "\">\n        ", "<span class=\"pvd-list-group__list-item-text\">", "</span>", "\n      </li>\n    "], ["\n      <li class=\"", "\">\n        ", "<span class=\"pvd-list-group__list-item-text\">", "</span>", "\n      </li>\n    "])), className, iconOrListStyle, text, iconRight);
    };
    /**
     * Render a list item object with a preference for the list item's
     * inidividual configuration over the values of the custom element's
     * attributes.
     * @param listItem object with properties required to render a more complex list item
     * @param listItemIndex position of the list item within the list, starts at 0
     */
    PvdListGroup.prototype.renderListItemObject = function (listItemObject, listItemIndex) {
        var isLink = typeof listItemObject.href === 'string';
        var textOrLink = isLink
            ? this.renderListItemObjectLink(listItemObject)
            : this.renderText(listItemObject.text);
        var leftIcon = listItemObject.iconLeft !== false
            ? this.renderListItemObjectIcon(IconPosition.left, listItemObject.iconLeft, this.pvdIconLeft, isLink)
            : A;
        var iconRight = listItemObject.iconRight !== false
            ? this.renderListItemObjectIcon(IconPosition.right, listItemObject.iconRight, this.pvdIconRight, isLink)
            : A;
        // left icons take the place of ordered and unordered list style
        var iconOrListStyle = leftIcon !== A ? leftIcon : this.renderListItemStyle();
        var nestedListGroup = listItemObject.listGroup
            ? this.renderNestedListGroup(listItemObject.listGroup)
            : A;
        var classMap = {
            default: "pvd-list-group__list-item",
            modifierPrefix: 'pvd-list-group__list-item',
            modifiers: [
                {
                    condition: listItemObject.border ||
                        (this.pvdBorders && listItemIndex > 0 && listItemObject.border !== false),
                    className: 'border',
                },
            ],
        };
        return x(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      <li class=\"", "\">\n        ", "<span class=\"pvd-list-group__list-item-text\">", "</span\n        >", "", "\n      </li>\n    "], ["\n      <li class=\"", "\">\n        ", "<span class=\"pvd-list-group__list-item-text\">", "</span\n        >", "", "\n      </li>\n    "])), getClassName(classMap), iconOrListStyle, textOrLink, iconRight, nestedListGroup);
    };
    /**
     * Render elements needed for the unordered and ordered list style.
     */
    PvdListGroup.prototype.renderListItemStyle = function () {
        if (this.pvdListStyle === undefined || this.pvdListStyle === ListStyle.none) {
            return A;
        }
        var listStyleA11yText = this.pvdListStyle === ListStyle.unordered
            ? x(templateObject_3 || (templateObject_3 = __makeTemplateObject(["<span class=\"pvd-list-group__list-item-a11y-text\">Bullet</span>"], ["<span class=\"pvd-list-group__list-item-a11y-text\">Bullet</span>"]))) : A;
        return x(templateObject_4 || (templateObject_4 = __makeTemplateObject(["<span class=\"pvd-list-group__list-item-style\">", "</span>"], ["<span class=\"pvd-list-group__list-item-style\">", "</span>"])), listStyleA11yText);
    };
    /**
     * Render text in accordance with the value of the `pvdEnableUnsafeHTML`
     * attribute.
     * @param text string to be rendered as the list item's text
     */
    PvdListGroup.prototype.renderText = function (text) {
        return this.pvdEnableUnsafeHTML ? o(text) : text;
    };
    /**
     * Render an icon, preferring the icon configuration of the individual list
     * item over the globally configured icon configuration
     * @param position position where the icon should be rendered
     * @param listItemIconName individual list item icon configuration
     * @param globalIconName global icon configuration
     */
    PvdListGroup.prototype.renderListItemObjectIcon = function (position, listItemIconName, globalIconName, isLink) {
        // prefer list item icon over global icon
        var iconName = listItemIconName || globalIconName;
        return iconName ? this.renderIcon(position, iconName, isLink) : A;
    };
    PvdListGroup.prototype.renderListItemObjectLink = function (listItemObject) {
        var text = this.renderText(listItemObject.text);
        // prettier-ignore
        return this.scopeTemplate(templateObject_5 || (templateObject_5 = __makeTemplateObject(["<pvd-scoped-link\n      pvd-disabled=", "\n      pvd-disable-underline\n      pvd-href=\"", "\"\n      pvd-native-anchor-attributes='", "'\n      pvd-new-window=", "\n    >", "</pvd-scoped-link>"], ["<pvd-scoped-link\n      pvd-disabled=", "\n      pvd-disable-underline\n      pvd-href=\"", "\"\n      pvd-native-anchor-attributes='", "'\n      pvd-new-window=", "\n    >", "</pvd-scoped-link>"])), !!listItemObject.disabled, listItemObject.href, JSON.stringify(listItemObject.nativeAnchorAttributes || {}), !!listItemObject.newWindow, text);
    };
    PvdListGroup.prototype.renderIcon = function (position, iconName, isLink) {
        var classMap = {
            default: "pvd-list-group__list-item-icon",
            modifierPrefix: 'pvd-list-group__list-item-icon',
            modifiers: [
                {
                    condition: isLink,
                    className: 'link',
                },
                {
                    condition: true,
                    className: position,
                },
            ],
        };
        return this.scopeTemplate(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n      <span class=\"", "\">\n        <pvd-scoped-icon\n          pvd-name=\"", "\"\n          pvd-size=\"", "\"\n        ></pvd-scoped-icon>\n      </span>\n    "], ["\n      <span class=\"", "\">\n        <pvd-scoped-icon\n          pvd-name=\"", "\"\n          pvd-size=\"", "\"\n        ></pvd-scoped-icon>\n      </span>\n    "])), getClassName(classMap), iconName, this.pvdSize === StandardSize.large ? Size.medium : Size.small);
    };
    /**
     * Render a nested List Group
     * @param listGroup
     */
    PvdListGroup.prototype.renderNestedListGroup = function (listGroup) {
        // nested lists only supported for stacked lists
        if (this.pvdInline !== Inline.never) {
            console.warn("[".concat(this.constructor.namespace, "-list-group] inline lists do not support nested lists"));
            return A;
        }
        return this.scopeTemplate(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n      <div class=\"pvd-list-group__nested-list\">\n        <pvd-scoped-list-group\n          pvd-borders=\"", "\"\n          pvd-icon-left=\"", "\"\n          pvd-icon-right=\"", "\"\n          pvd-list-items=\"", "\"\n          pvd-size=\"", "\"\n          pvd-list-style=\"", "\"\n        ></pvd-scoped-list-group>\n      </div>\n    "], ["\n      <div class=\"pvd-list-group__nested-list\">\n        <pvd-scoped-list-group\n          pvd-borders=\"", "\"\n          pvd-icon-left=\"", "\"\n          pvd-icon-right=\"", "\"\n          pvd-list-items=\"", "\"\n          pvd-size=\"", "\"\n          pvd-list-style=\"", "\"\n        ></pvd-scoped-list-group>\n      </div>\n    "])), l(listGroup.borders), l(listGroup.iconLeft), l(listGroup.iconRight), JSON.stringify(listGroup.listItems), l(listGroup.size || this.pvdSize), l(listGroup.listStyle));
    };
    PvdListGroup.prototype.render = function () {
        var classMap = {
            default: "".concat(this.constructor.namespace, "-list-group-root"),
            modifierPrefix: 'pvd-list-group',
            modifiers: [
                {
                    condition: this.pvdInline !== DEFAULT_INLINE,
                    className: "inline-".concat(this.pvdInline),
                },
                {
                    condition: this.pvdListStyle !== DEFAULT_LIST_STYLE,
                    className: this.pvdListStyle,
                },
                {
                    condition: this.pvdSize !== DEFAULT_SIZE,
                    className: "".concat(this.pvdSize),
                },
            ],
        };
        var listItems = this.pvdListItems.map(this.renderListItem.bind(this));
        // role="list" is required in Safari when "list-style: none;" in order to
        // support screen readers. setting it always to be safe.
        var role = 'list';
        return this.pvdListStyle === ListStyle.ordered
            ? x(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n          <ol\n            aria-labelledby=\"", "\"\n            class=\"", "\"\n            role=\"", "\"\n          >\n            ", "\n          </ol>\n        "], ["\n          <ol\n            aria-labelledby=\"", "\"\n            class=\"", "\"\n            role=\"", "\"\n          >\n            ", "\n          </ol>\n        "])), l(this.pvdAriaLabelledby), getClassName(classMap), role, listItems) : x(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n          <ul\n            aria-labelledby=\"", "\"\n            class=\"", "\"\n            role=\"", "\"\n          >\n            ", "\n          </ul>\n        "], ["\n          <ul\n            aria-labelledby=\"", "\"\n            class=\"", "\"\n            role=\"", "\"\n          >\n            ", "\n          </ul>\n        "])), l(this.pvdAriaLabelledby), getClassName(classMap), role, listItems);
    };
    //#region Component configuration
    PvdListGroup.componentName = 'list-group';
    __decorate([
        n({ type: String, reflect: true, attribute: 'pvd-aria-labelledby' }),
        __metadata("design:type", String)
    ], PvdListGroup.prototype, "pvdAriaLabelledby", void 0);
    __decorate([
        n(_assign({ type: Boolean, reflect: true, attribute: 'pvd-borders' }, PvdBaseComponent.booleanAttribute('pvd-borders'))),
        __metadata("design:type", Boolean)
    ], PvdListGroup.prototype, "pvdBorders", void 0);
    __decorate([
        n(_assign({ type: Boolean, reflect: true, attribute: 'pvd-enable-unsafe-html' }, PvdBaseComponent.booleanAttribute('pvd-enable-unsafe-html'))),
        __metadata("design:type", Boolean)
    ], PvdListGroup.prototype, "pvdEnableUnsafeHTML", void 0);
    __decorate([
        n({ type: String, reflect: true, attribute: 'pvd-icon-left' }),
        __metadata("design:type", String)
    ], PvdListGroup.prototype, "pvdIconLeft", void 0);
    __decorate([
        n({ type: String, reflect: true, attribute: 'pvd-icon-right' }),
        __metadata("design:type", String)
    ], PvdListGroup.prototype, "pvdIconRight", void 0);
    __decorate([
        n(_assign({ type: String, reflect: true, attribute: 'pvd-inline' }, PvdBaseComponent.hasChanged(Inline))),
        __metadata("design:type", String)
    ], PvdListGroup.prototype, "pvdInline", void 0);
    __decorate([
        n({ type: Array, reflect: false, attribute: 'pvd-list-items' }),
        __metadata("design:type", Array)
    ], PvdListGroup.prototype, "pvdListItems", void 0);
    __decorate([
        n(_assign({ type: String, reflect: true, attribute: 'pvd-size' }, PvdBaseComponent.hasChanged(StandardSize))),
        __metadata("design:type", Number)
    ], PvdListGroup.prototype, "pvdSize", void 0);
    __decorate([
        n(_assign({ type: String, reflect: true, attribute: 'pvd-list-style' }, PvdBaseComponent.hasChanged(ListStyle))),
        __metadata("design:type", String)
    ], PvdListGroup.prototype, "pvdListStyle", void 0);
    return PvdListGroup;
}(ScopedElementsMixin(PvdBaseComponent)));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;

export { DEFAULT_BORDERS, DEFAULT_ENABLE_UNSAFE_HTML, DEFAULT_INLINE, DEFAULT_LIST_STYLE, DEFAULT_SIZE, ListStyle, PvdListGroup };
